"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var class_names_1 = tslib_1.__importDefault(require("../../utils/helpers/class-names"));
var card_style_1 = require("../card.style");
var CardHeader = function (_a) {
    var children = _a.children, reverse = _a.reverse, border = _a.border, _b = _a.color, color = _b === void 0 ? 'inherit' : _b, className = _a.className;
    return (react_1["default"].createElement("div", { className: (0, class_names_1["default"])("flex flex-col w-full p-4 items-center justify-center bg-transparent", reverse ? card_style_1.REVERSE_COLORS[color] : card_style_1.COLORS[color], border ? "border ".concat(card_style_1.BORDER_COLORS[color], " rounded-t-2xl") : 'border-0', className) }, children));
};
exports["default"] = CardHeader;
//# sourceMappingURL=card-header.js.map